import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@app/components/button/button.module';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalMyLifeActsBlocksComponent } from '@app/myWeeklyLifeActs/modalMyLifeActsBlocks/modalMyLifeActsBlocks.component';
import { MyLifeActsBlocksModule } from '@app/myWeeklyLifeActs/myLifeActsBlocks/myLifeActsBlocks.module';
import { MyLifeActsDownloadButtonModule } from '@app/myWeeklyLifeActs/myLifeActsDownloadButton/myLifeActsDownloadButton.module';
import { LoaderModule } from '@shared/loader/loader.module';

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    MatDialogModule,
    PlIconModule,
    TranslateModule,
    MyLifeActsBlocksModule,
    MyLifeActsDownloadButtonModule,
    LoaderModule,
  ],
  declarations: [ModalMyLifeActsBlocksComponent],
  exports: [ModalMyLifeActsBlocksComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalMyLifeActsBlocksModule {}
